// extracted by mini-css-extract-plugin
export default {"main":"#76aec9","light":"#aeddf3","dark":"#145779","contrasttext":"#f5f3f1","errorColor":"#d32f2f"};